import TransportVehiclesService from '@/api/TransportVehiclesService.js'
import Vue from 'vue'
export const transportVehiclesModule = {
  namespaced: true,
  state: () => ({
    transportVehiclesData: [],
    transportVehiclesLoadStatus: 'request',
    lineHealthVehicle: [],
    lineTitle: {},
    transportVehiclesSelects: null,
    paginationStateParams: {
      count: 0,
      limit: 50,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationStateParams.total / state.paginationStateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.transportVehiclesData = [...data]
    },
    create(state, data) {
      state.transportVehiclesData.unshift(data)
    },
    edit_multiple(state, data) {
      let indexed = state.transportVehiclesData.findIndex(
        (x) => x.vehicles__id == data.id
      )

      state.transportVehiclesData[indexed] = Object.assign(
        state.transportVehiclesData[indexed],
        data.data.rows[0]
      )
    },

    delete_data(state, id) {
      let indexed = state.transportVehiclesData.findIndex(
        (x) => x.place_deliveries__place_id == id
      )
      state.transportVehiclesData.splice(indexed, 1)
    },

    update_pagination(state, payload) {
      const apiData = payload?.apiData || {}
      const requestParams = payload?.requestParams || {}

      const rowsCount = Array.isArray(apiData.rows) ? apiData.rows.length : 0
      const parsedCount = Number(apiData.count)
      const count = Number.isFinite(parsedCount) && parsedCount >= 0
        ? parsedCount
        : rowsCount

      const parsedTotal = Number(apiData.total)
      const total = Number.isFinite(parsedTotal) && parsedTotal > 0
        ? parsedTotal
        : (count > 0 ? count : 0)

      const requestedLimit = Number(requestParams.limit)
      const apiLimit = Number(apiData.limit)
      const limit = Number.isFinite(requestedLimit) && requestedLimit > 0
        ? requestedLimit
        : (Number.isFinite(apiLimit) && apiLimit > 0
          ? apiLimit
          : state.paginationStateParams.limit)

      const requestedPage = Number(requestParams.page)
      const apiPage = Number(apiData.page)
      const page = Number.isFinite(requestedPage) && requestedPage > 0
        ? requestedPage
        : (Number.isFinite(apiPage) && apiPage > 0 ? apiPage : 1)

      state.paginationStateParams = { total, count, limit, page }
    },
    update_line_health_vehicle(state, data) {
      state.lineHealthVehicle = data
    },
    update_title(state, data) {
      state.lineTitle = data
    },

    update_selects(state, selects) {
      state.transportVehiclesSelects = selects
    },

    load_request(state, status) {
      state.transportVehiclesLoadStatus = 'request'
    },
    load_success(state) {
      state.transportVehiclesLoadStatus = 'success'
    },
    load_error(state) {
      state.transportVehiclesLoadStatus = 'error'
    }
  },
  actions: {
    getTransportVehiclesAll({ commit }, params) {
      commit('load_request')

      TransportVehiclesService.getAll({ params: params })
        .then((data) => {
          const payload = data?.data?.data || {}
          commit('update_pagination', {
            apiData: payload,
            requestParams: params
          })
          commit('update_selects', payload?.selects || null)
          commit(
            'get_all',
            (payload.rows || []).map((x) => {
              x.rowKey = x.vehicles__id
              return x
            })
          )
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    downloadTransportVehiclesExel({ commit }, params) {
      TransportVehiclesService.downloadExel({ params: params })
        .then((data) => {
          // commit('update_pagination', data.data.data)
          // commit('get_all', data.data.data.rows)
          // commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    createTransportVehiclesData({ commit }, { data, callback }) {
      TransportVehiclesService.create(data)
        .then((data) => {
          // commit('create', data.data.data.rows[0])
          callback()
          Vue.$toast.success('Запись добавлена')

          return true
        })
        .catch((error) => {
          callback(error.response.data.errors)
          Vue.$toast.error(error.response.data.message, { duration: 5000 })
          return false
        })
    },

    editTransportVehiclesMultiple(
      { commit },
      { id, data, callback, typeOfClose }
    ) {
      TransportVehiclesService.update(id, data)
        .then((data) => {
          callback()
          Vue.$toast.success('Данные успешно обновлены')
          return true
        })
        .catch((error) => {
          callback(error.response.data.errors, typeOfClose)
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          return false
        })
    },
    getHealth({ commit }, id) {
      if (id) {
        TransportVehiclesService.getHealth(id)
          .then((data) => {
            const healthPayload = data?.data?.data || {}
            const normalizedRows = Array.isArray(healthPayload?.rows)
              ? healthPayload.rows
              : Object.values(healthPayload)

            commit('update_line_health_vehicle', normalizedRows)
          })
          .catch((error) => {
            Vue.$toast.error('Ошибка загрузки строки здоровья', { duration: 5000 })
          })
      }
    },
    getTitle({ commit }, id) {
      if (id) {
        TransportVehiclesService.getTitle(id)
          .then((data) => {
            commit('update_title', data.data.data.rows[0])
          })
          .catch((error) => {
            Vue.$toast.error('Ошибка загрузки строки здоровья', { duration: 5000 })
          })
      }
    },
    toArchiveTransportVehiclesMultiple({ commit, dispatch, getters, state }, payload) {
      console.log(payload);

      commit('load_request')
      TransportVehiclesService.toArchive(payload.listIds.join(), payload.pincode)
        .then((data) => {
          // commit('edit_multiple', { id: id, data: data.data.data })
          dispatch('getTransportVehiclesAll', {
            limit: state.paginationStateParams.limit,
            page: getters.numPages,
            type: 'car'
          })
          commit('load_success')
          Vue.$toast.success(data.data.message)
        })
        .catch((error) => {
          dispatch('getTransportVehiclesAll', {
            limit: state.paginationStateParams.limit,
            page: getters.numPages,
            type: 'car'
          })
          commit('load_error')
          Vue.$toast.error(error.response.data.message, { duration: 5000 })
        })
    },
    duplicateTransportVehiclesMultiple({ commit, dispatch, getters, state }, listIds) {
      commit('load_request')
      TransportVehiclesService.duplicate(listIds.join())
        .then((data) => {
          // commit('edit_multiple', { id: id, data: data.data.data })
          dispatch('getTransportVehiclesAll', {
            limit: state.paginationStateParams.limit,
            page: 1,
            type: 'car'
          })
          commit('load_success')
          Vue.$toast.success(data.data.message)
        })
        .catch((error) => {
          dispatch('getTransportVehiclesAll', {
            limit: state.paginationStateParams.limit,
            page: 1,
            type: 'car'
          })
          commit('load_error')
          Vue.$toast.error(error.response.data.message, { duration: 5000 })
        })
    },

    deleteTransportVehiclesData({ commit, dispatch, getters, state }, listIds) {
      commit('load_request')
      TransportVehiclesService.deleteMultiple(listIds.join())
        .then((data) => {
          dispatch('getTransportVehiclesAll', {
            limit: state.paginationStateParams.limit,
            page: 1,
            type: 'car'
          })
          commit('load_success')
          Vue.$toast.success(data.data.message)
        })
        .catch((error) => {
          dispatch('getTransportVehiclesAll', {
            limit: state.paginationStateParams.limit,
            page: 1,
            type: 'car'
          })
          commit('load_error')

          Vue.$toast.error(error.response.data.message, { duration: 5000 })
        })
    },
    async toExcelTransportVehiclesData({ commit, dispatch, getters }, filter) {
      commit('load_request')
      let dataFrom = await TransportVehiclesService.toExcel(filter)

      const filename = new Date().toISOString()
      const url = window.URL.createObjectURL(dataFrom.data)
      const a = document.createElement('a')
      a.href = url
      a.download = `${filename}.xlsx`
      document.body.appendChild(a)
      a.click()
      a.remove()
      commit('load_success')
      // .then(
      //   (data) => data.blob()
      //   //   if (blob != null) {
      //   //     const filename = new Date().toISOString();
      //   //     const url = window.URL.createObjectURL(blob);
      //   //     const a = document.createElement('a');
      //   //     a.href = url;
      //   //     a.download = `${filename}.xlsx`;
      //   //     document.body.appendChild(a);
      //   //     a.click();
      //   //     a.remove();
      //   //   }
      // )
      // .then((data) => {
      //
      // })
      // .catch((error) => {
      //   commit('load_error')
      //
      //   Vue.$toast.error(error.response.data.message, {duration: 5000})
      // })
    }
  }

  // async loadDoc() {
  //   let datas = await fetch('http://api.yandexrent.development/vehicles/table/convert/xlsx?type=car&where=[]', {
  //     headers: {
  //       'X-Employee-Token':
  //         'dsAuUj8c7q7R2zqfX6ciWkm9EBnnWazCitsqovUd0aNf3SoqxTmGtRap7IKteERi8Kiiu+v6qU14swaBWz9/uIL0TXS7HV/33pzGHsfChvZbiOzW8rbl+ZSXZfoRwj7KebAf7kNN9k1GWko5lDDE+dHq5iwaugZ5BxC6U+Gtvsb+N3lD7aNOkWDUKy5FOAnszt5amEUyfq2GXxLXNJ39jg==',
  //     },
  //   });
  //   //   Здесь нужно присвоить ответ для реактивного отобраения в шаблоне
  //   // Например: this.resultTest = await datas.json()
  //   const blob = await datas.blob();
  //   if (blob != null) {
  //     const filename = new Date().toISOString();
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = `${filename}.xlsx`;
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //   }
  // },
}
